import { ERROR_MESSAGE_MAP } from './const';

/**
 * 根据后端返回的错误 key 获取本地 i18n 消息 key
 */
export function getErrorMessage(key?: string) {
  if (!key) {
    return 'Something went wrong';
  }

  if (key === 'USER_NOT_LOGIN' && window.location.pathname === '/login') {
    return '';
  }

  if (ERROR_MESSAGE_MAP[key]) {
    return ERROR_MESSAGE_MAP[key];
  }
  return 'Something went wrong';
}

/**
 * 获取 API Base URL
 * 优先使用调试面板配置的自定义 URL，否则使用默认 URL
 */
export function getApiBaseUrl(): string {
  try {
    const debugSettings = localStorage.getItem('debug-settings');
    if (debugSettings) {
      const { state } = JSON.parse(debugSettings);
      if (state?.useCustomApiBaseUrl && state?.customApiBaseUrl) {
        return state.customApiBaseUrl;
      }
    }
  } catch (error) {
    console.error('Failed to get debug settings:', error);
  }
  return '';
}

/**
 * 获取自定义 Cookie
 * 如果启用了自定义 Cookie 配置，返回配置的 Cookie 字符串
 */
export function getCustomCookie(): string | undefined {
  try {
    const debugSettings = localStorage.getItem('debug-settings');
    if (debugSettings) {
      const { state } = JSON.parse(debugSettings);
      if (state?.useCustomCookie && state?.customCookie) {
        return state.customCookie;
      }
    }
  } catch (error) {
    console.error('Failed to get debug cookie settings:', error);
  }
  return undefined;
}

export const getRequestAPIUrl = () => `/api/onepage`;

export const getUserAPIUrl = () => `/api/user/v1`;

export const getUserAPIUrlV2 = () => `/api/user/v2`;

export const getAssetsAPIUrl = () => `/api/assets`;

export const getAgentsAPIUrl = () => `${getApiBaseUrl()}/api/agents`;

/** 开发环境代理域名 */
const DEV_PROXY_ORIGIN = 'https://dev.wegic-tx.geesdev.com';

/**
 * 获取当前页面的有效 origin
 * 如果是 localhost 开发环境，返回开发代理域名
 */
function getEffectiveOrigin(): string {
  const { origin } = window.location;
  if (origin.includes('localhost')) {
    return DEV_PROXY_ORIGIN;
  }
  return origin;
}

/**
 * 将相对路径 URL 转换为绝对路径
 * 用于 iframe 跨域场景，确保 URL 不依赖 iframe 的域名
 *
 * @param url - 可能是相对路径或绝对路径的 URL
 * @returns 绝对路径 URL
 *
 * @example
 * // 绝对路径直接返回
 * resolveAbsoluteUrl('https://api.example.com/upload') // 'https://api.example.com/upload'
 *
 * // 相对路径拼接 origin
 * resolveAbsoluteUrl('/api/agents/upload') // 'https://current-origin.com/api/agents/upload'
 *
 * // localhost 开发环境使用代理域名
 * // 当 window.location.origin 为 'http://localhost:3000' 时
 * resolveAbsoluteUrl('/api/agents/upload') // 'https://dev.wegic-tx.geesdev.com/api/agents/upload'
 */
export function resolveAbsoluteUrl(url: string): string {
  // 已经是绝对路径，直接返回
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }

  // 相对路径，拼接有效 origin
  const origin = getEffectiveOrigin();
  // 确保路径以 / 开头
  const path = url.startsWith('/') ? url : `/${url}`;
  return `${origin}${path}`;
}
